import { NormalText } from 'components/styled/text.styled';
import { InputField } from 'components/Inputs/Input';
import { TextArea } from 'components/Inputs/TextArea';
import BackgroundImage from 'components/layouts/BackgroundImage';
import SelectOption from 'components/Inputs/SelectOption';
import { ImageSource } from 'modules/assetpath';
import { Box, Stack } from 'components/styled/layout.styled';
import GradientButton from 'components/Buttons/GradientButton';
import React, { useState } from 'react';
import AppLayout from 'components/layouts/AppLayout';
import history from 'modules/history';

const AddSchool = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <AppLayout
    noMargin={true}
    opacityBg='0.04' 
    appBar={{
      bg: {},
      navleft: {
        bg: 'ic-arrow-back-light',
        width: '24px',
        height: '24px',
        onClick: ()=> history.push('/account/edit')
      },
      navright: {
        variant: 'empty'
      },
      isDisable: false,
      title: `Penambahan Sekolah`
    }}
      backgroundImage={ImageSource('app.background')}
      showModal={showModal}
      modalContent={
        <Box padding="16px" width="100%">
          <Stack direction="column" margin="16px">
            <NormalText
              textAlign="center"
              color="#FFFFFF"
              fontSize="16px"
              fontWeight="bold"
              margin="8px 0px"
            >
              Terima Kasih!
            </NormalText>
            <NormalText
              textAlign="center"
              color="#969393"
              fontSize="14px"
              fontWeight="normal"
              margin="8px 0px"
            >
              Kami telah menerima permintaanmu.
            </NormalText>
            <br />
            <Box padding="8px" width="100%">
              <Stack direction="column" align="center">
                <GradientButton
                  onClick={() => setShowModal(false)}
                  styled={{
                    backgroundSize: '100%',
                    width: '180px',
                  }}
                  variant="primary"
                >
                  OK
                </GradientButton>
              </Stack>
            </Box>
          </Stack>
        </Box>
      }
    >
      <BackgroundImage
        src={ImageSource('card.background')}
        backgroundColor="#131318"
        mask="linear-gradient(transparent, #00000090, #00000023, transparent)"
        //   styled={styled}
      >
        <NormalText
          style={{ marginLeft: '10px', marginRight: 'auto', marginTop: '35px' }}
          fontSize="18px"
          fontWeight="bold"
          lineHeight="140%"
          color="white"
          textAlign="left"
        >
          Sekolah Kamu Belum Terdaftar?
        </NormalText>
        <NormalText
          style={{ marginBottom: '40px' }}
          fontSize="12px"
          fontWeight="normal"
          lineHeight="140%"
          color="#DDD8D8"
          textAlign="left"
          margin="10px"
        >
          Jika kamu ingin mendaftarkan sekolah di Mabar.com, silahkan isi form di bawah ini.
        </NormalText>
      </BackgroundImage>
      <div style={{margin: '12px'}}>
        <InputField
          label="Nama"
          onChange={() => {}}
          inputMode="text"
          // onClick={function noRefCheck() {}}
          placeholder="John Doe"
        />
        <InputField
          label="Email"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="johndoe@gmail.com"
          inputMode="email"
        />
        <InputField
          label="Nomor Ponsel"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="0812xxxxxxx"
          inputMode="tel"
        />
        <InputField
          label="Tipe Laporan"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="Permintaan Penambahan Sekolah"
          inputMode="text"
          style={{background:'rgba(46, 50, 56, 0.6)'}}
          disabled={true}
        />
        <InputField
          label="Nama Sekolah"
          onChange={() => {}}
          inputMode="text"
          // onClick={function noRefCheck() {}}
          placeholder="Nama Sekolah Kamu"
        />
        <InputField
          label="Nomor Pokok Sekolah Nasional (NPSN)"
          onChange={() => {}}
          inputMode="numeric"
          type="number"
          // onClick={function noRefCheck() {}}
          placeholder="Nomor Pokok Sekolah Nasional"
        />
        <InputField
          label="Nomor Telepon Sekolah"
          onChange={() => {}}
          inputMode="tel"
          // onClick={function noRefCheck() {}}
          placeholder="Nomor telepon sekolah Kamu"
        />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'Jawa Barat',
              value: 'westjava',
            },
            {
              label: 'Jawa Timur',
              value: 'eastjava',
            },
            {
              label: 'DKI Jakarta',
              value: 'jakarta',
            },
          ]}
          placeholder="Pilih Provinsi"
          label="Provinsi"
        />
        <br />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'Bandung',
              value: 'bandung',
            },
            {
              label: 'Surabaya',
              value: 'surabaya',
            },
            {
              label: 'Jakarta',
              value: 'jakarta',
            },
          ]}
          placeholder="Pilih Kota"
          label="Kota"
        />
        <br />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'Cilandak',
              value: 'sma2bdg',
            },
            {
              label: 'Cilaki',
              value: 'sma1bdg',
            },
            {
              label: 'Lengkong',
              value: 'sma3bdg',
            },
          ]}
          placeholder="Pilih Kecamatan"
          label="Kecamatan"
        />
        <br />
        <TextArea
          label="Alamat Spesifik"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="Masukkan Alamat lengkap Kamu"
          inputMode="text"
          type="textarea"
        />
        <br />
        <Box padding="8px" width="100%">
          <Stack direction="column" align="center">
            <GradientButton
              onClick={() => setShowModal(true)}
              styled={{
                backgroundSize: '100%',
                width: '100px',
              }}
              variant="primary"
            >
              Kirim
            </GradientButton>
          </Stack>
        </Box>
      </div>
    </AppLayout>
  );
};

export default AddSchool;
